import { PersonMatchProfilesDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';
import {
  getSearchParams,
  formatLocationIdParam,
  formatPersonProfileIdParam,
} from './utils';

export function usePersonMatchProfiles(
  locationId: number[],
  searchParams = '',
  enabled = true,
  personProfileId?: string[]
) {
  const paramsString = getSearchParams(
    locationId,
    searchParams,
    personProfileId
  );

  const url = `/v2/orm/person_profile?${paramsString}`;
  const request = new Request(url);
  const locationIdsParam = formatLocationIdParam(locationId);
  const personProfileIdParam = formatPersonProfileIdParam(personProfileId);

  return useAuthenticatedRequest<PersonMatchProfilesDTO>(request, {
    queryKey: [
      'person_match_profiles',
      {
        locationIds: locationIdsParam,
        personProfileId: personProfileIdParam,
        searchParams,
      },
    ],
    enabled,
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}

export default usePersonMatchProfiles;
